import { getClient } from '@api/client';
import { graphql } from '@api/generated/gql';
import { ServiceUserUtils } from '@modules/ServiceModule/workspace/lib/serviceUserUtils';

const getCurrentUserAvailabilityQuery = graphql(`
  query currentUserAvailability {
    currentUser {
      availabilityActivityStatus {
        availabilityStatus
        activityStatus
      }
    }
  }
`);

export const getUserStatusQuery = () => getCurrentUserAvailabilityQuery;

async function getCurrentUserStatus() {
  const { data, error } = await getClient().query({
    fetchPolicy: 'network-only',
    query: getUserStatusQuery(),
  });

  if (error) {
    throw new Error(error.message);
  }

  if (!data?.currentUser) {
    throw new Error('Current user not found');
  }

  return ServiceUserUtils.parseAvailabilityStatus(data.currentUser);
}

export default getCurrentUserStatus;
